export const settingsApi = '/api/v1/common/settings/';
